import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GLMMaterialDesignModule} from '../material-design/material-design.module';
import {GlmComentariosComponent} from './glm-comentarios.component';
import {FormsModule} from '@angular/forms';
import {SingleCommentComponent} from './single-comment/single-comment.component';

@NgModule({
    imports: [CommonModule, GLMMaterialDesignModule, FormsModule],
    exports: [GlmComentariosComponent, SingleCommentComponent],
    declarations: [GlmComentariosComponent, SingleCommentComponent],
    providers: [],
})
export class GlmComentariosModule {
}
